module.exports = __webpack_public_path__ + "components/rewards/panda-optics/static/logo-6a9e3bfebc32c456fe8e478ead28325c.webp";